var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form__wrapper"},[_c('img',{staticClass:"logo",attrs:{"src":require("../assets/logo.png")}}),_c('h1',[_vm._v("You're all set!")]),_c('p',[_vm._v("Your proton.ai account has been created with the provided credentials.")]),_c('a',{attrs:{"href":_vm.loginUrl}},[_c('el-button',{attrs:{"type":"text"}},[_vm._v("Log in now")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }